import { render, staticRenderFns } from "./practiceList.vue?vue&type=template&id=1cd0fd3a&scoped=true"
import script from "./practiceList.vue?vue&type=script&lang=js"
export * from "./practiceList.vue?vue&type=script&lang=js"
import style0 from "./practiceList.vue?vue&type=style&index=0&id=1cd0fd3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0fd3a",
  null
  
)

export default component.exports